import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Scrollable but no visible scrollbar (panel body). */
const hiddenScrollbar = css`
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;

/**
 * Inspector panel — lives inside ContentRow, attached to the canvas card.
 * Width is percentage-based; min/max guard the Figma 300px target.
 */
export const PanelRoot = styled.aside`
  width: 45%;
  min-width: 260px;
  max-width: 500px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background-color: ${rawColors.structural[50]};
  border-left: 1px solid ${rawColors.stroke[200]};
  overflow: hidden;
`;

export const PanelInner = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${rawColors.structural.white};
  overflow: hidden;
`;

export const PanelBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  ${hiddenScrollbar}
`;

export const EmptyState = styled.div`
  padding: ${spacing[6]};
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
  text-align: center;
`;
